import { render } from "./HistoryClaimPage.vue?vue&type=template&id=4e6af57e&ts=true"
import script from "./HistoryClaimPage.vue?vue&type=script&lang=ts"
export * from "./HistoryClaimPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__